/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {

  // Common Labels for both calendars
  calendarLabels: [
      { text: 'Business' ,value : 'business', color: 'success' },
      { text: 'Work', value: 'work', color: 'warning'},
      { text: 'Personal', value: 'personal', color: 'danger'},
      { text: 'Todo', value: 'todo', color: 'primary'},
  ],

  calendarEvents: [],

  // Simple Calendar State
  simpleCalendarEvents: [],

  // Review Assignments for Calendar
  reviewAssignments: []
}
